import { useState } from 'react';
import { prefersReducedMotion } from '~/store/settingsStore.js';

/**
 * Whether a moment should be drawn still rather than animated.
 *
 * One check, so the setting, the operating system's preference and a still
 * table (`data-motion="none"`) mean the same thing everywhere a panel or an
 * effect asks.
 */

/** The setting, or the operating system's own preference. Either is enough. */
export function stillWanted(reducedMotion: boolean): boolean {
  return reducedMotion || prefersReducedMotion();
}

/**
 * `stillWanted`, read once when the screen opens. A screen that settles over
 * its first second keeps the answer it started with, so switching the setting
 * mid-arrival cannot flip an animation that is already running.
 */
export function useStill(reducedMotion: boolean): boolean {
  const [still] = useState(() => stillWanted(reducedMotion));
  return still;
}

/** The node stands inside a still table, or the operating system asks for less motion. */
export function drawnStill(node: Element): boolean {
  return node.closest('[data-motion="none"]') !== null || prefersReducedMotion();
}
